import gym from "../../../assets/images/usercardsGymsPhoto.png";
import dance from "../../../assets/images/usercardsdance.png";
import yoga from "../../../assets/images/usercardsyoga.png";
import fitness from "../../../assets/images/usercardsfitness.png";
import Pool from "../../../assets/images/swimming pool.png";

function Section3() {
  return (
    <div>
      <div className="HomeScreen-Section3-grid">
        <div className="grid-item">
          <img src={gym} alt="" className="HomeScreen-Section3-img" />
        </div>
        <div className="grid-item">
          <img src={dance} alt="" className="HomeScreen-Section3-img" />
        </div>
        <div className="grid-item">
          <img src={yoga} alt="" className="HomeScreen-Section3-img" />
        </div>
        <div className="grid-item">
          <img src={fitness} alt="" className="HomeScreen-Section3-img" />
        </div>
        <div className="grid-item">
          <img src={Pool} alt="" className="HomeScreen-Section3-img" />
        </div>
      </div>
      <br />
      <br /> <br /> <br />
    </div>
  );
}
export default Section3;
